import * as React from 'react'
import { QueryClientProvider } from 'react-query';
import { QueryClient, DefaultOptions } from 'react-query';
import { Toaster } from 'react-hot-toast';
import TrackingBootstrap from '../components/tracking-bootstrap';
const queryConfig: DefaultOptions = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });

const layout = ({children}: any) => {
  return (<QueryClientProvider client={queryClient}>
    <TrackingBootstrap />
    <Toaster/ >
    {children}
  </QueryClientProvider>)
}

export default layout;